<ng-container *transloco="let t">
  <div
    (click)="onChange()"
    [class.desktop]="(biggerThan$ | async)?.sm"
    class="installments-calculator flex"
    [cdkTrapFocus]="true">
    <div class="options">
      <span class="fixed-space-16" aria-hidden="true"></span>

      <div class="flex flex-col">
        <label class="label" [for]="'amountForm'">
          2. {{ t('label_purchase_amount') }}</label
        >
        <span class="fixed-space-12" aria-hidden="true"></span>

        <popsy-input
          type="text"
          [label]="''"
          [autocomplete]="'off'"
          [value]="amount?.toFixed(0)"
          [userChangesOnly]="true"
          [initialized]="true"
          (debouncedValueChange)="onAmountChange($event)">
        </popsy-input>
        <app-slider-input
          [value]="amount || 0"
          [minAmount]="minValue"
          [step]="1"
          [direction]="direction$ | async"
          [maxAmount]="maxValue"
          [currency]="currency"
          (livePrice)="onAmountChange($event)" />
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>

      <div class="flex flex-col">
        <label class="label" [for]="'installmentsForm'">
          3. {{ t('label_payment_plan') }}
        </label>
        <span class="fixed-space-12" aria-hidden="true"></span>

        <div class="flex full-width align-center">
          <popsy-input
            class="short-field"
            type="text"
            [label]="''"
            [autocomplete]="'off'"
            [value]="installments?.toFixed(0)"
            [userChangesOnly]="true"
            [initialized]="true"
            (debouncedValueChange)="onInstallmentsChange($event)">
          </popsy-input>
          <span class="fixed-space-4" aria-hidden="true"></span>
          <span>
            {{
              installments <= 1 ? t('expiry_month_one') : t('expiry_month_other')
            }}</span
          >
        </div>

        <app-slider-input
          [value]="installments || 0"
          [minAmount]="minInstallments"
          [maxAmount]="maxInstallments"
          [direction]="direction$ | async"
          [step]="1"
          [range]="[1, 2, 3, 4, 6, 9, 12, 18, 24, 30, 36]"
          [currency]="currency"
          (livePrice)="onInstallmentsChange($event)" />
      </div>
    </div>
    <div class="results flex flex-col justify-between">
      <div>
        <span>{{ t('label_monthly_installments') }}</span>
        <h1 class="text-highlight">{{ calculatedInstallment() | amount }}</h1>
      </div>
      <span class="fixed-space-32" aria-hidden="true"></span>

      <span class="small text-gray-05 wrap">{{ t('desc_monthly_installments') }}</span>
      <!--  <span>{{ t('label_downpayment') }}</span>
      <h2 class="text-highlight">{{ calculatedDownpayment() | amount }}</h2> -->
    </div>
  </div>
</ng-container>
